// Module
var code = "<div class=\"vui-landing-page-header-link tw-cursor-pointer {{ $ctrl.type }} {{ $ctrl.location.path().startsWith($ctrl.path) || $ctrl.location.path().startsWith($ctrl.altPath) ? 'active' : ''  }}\">\n    <a class=\"tw-font-bold xs:tw-p-0 sm:tw-p-0\" ng-href=\"{{ $ctrl.path }}\">\n        <ng-transclude></ng-transclude>\n    </a>\n</div>\n";
// Exports
module.exports = code;